import { AppState } from 'pages';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  boardState,
  BoardStatus,
  setLenderDelete,
  setStatus
} from 'common/modules/app/board';
import { DeleteLendingUserBoard } from '../components/DeleteLendingUserBoard';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';
import {
  deleteLendingUser,
  deleteLendingUserSync,
  DELETE_LENDING_USER_ID
} from 'common/modules/domain/lendingUser';
import { endFetch, FetchState, FetchStatus } from 'common/modules/app/fetch';
import { PurchaseInitialState } from 'common/modules/domain/purchase';
import { UserInformation } from 'common/modules/domain/user';
import { Glossary } from 'common/utils/glossary';
import { GlossaryState } from 'common/modules/app/glossaries';

/**
 * StoreのStateからComponentに渡すPropsへ
 */

const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const purchaseState = useSelector<AppState, PurchaseInitialState>(
    (state) => state.domain.purchase
  );

  const isLendingUserProcessing =
    fetchState[DELETE_LENDING_USER_ID] !== null &&
    fetchState[DELETE_LENDING_USER_ID] === FetchStatus.PROCESSING;
  const isLendingUserProcessingFail =
    fetchState[DELETE_LENDING_USER_ID] !== null &&
    fetchState[DELETE_LENDING_USER_ID] === FetchStatus.FAILED;

  // 有償機能プランか否かのフラグ
  let isDeviceActivate = false;
  if (boardState.selectedPurchaseIdForLendingUser != '') {
    const purchaseInfo =
      purchaseState.purchasePlanList[
        boardState.selectedPurchaseIdForLendingUser
      ];
    if (purchaseInfo) {
      isDeviceActivate = purchaseInfo.plan.deviceLimitType == 2;
    }
  }

  return {
    isLendingUserProcessing,
    isLendingUserProcessingFail,
    purchaseId: boardState.selectedPurchaseIdForLendingUser,
    deleteUser: boardState.lendingIndex.deleteIndex,
    isDisplay: boardState.status === BoardStatus.DELETE_LENDING_USER_DISP,
    user: userState,
    isDeviceActivate: isDeviceActivate,
    glossary: Glossary.instance(glState)
  };
};

type SelectedState = ReturnType<typeof useStateProps>;

/**
 * Actionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const cookie = loadCookie();
  const _token = cookie[SasCookieKeys.KEY_TOKEN];
  const _refreshToken = cookie[SasCookieKeys.KEY_REFRESH_TOKEN];
  const _purchaseId = state.purchaseId;
  const _deleteUser = state.deleteUser;
  const _language = state.user.language;

  const onInit = () => {
    dispatch(endFetch(DELETE_LENDING_USER_ID));
  };

  /** 削除ボタンの押下処理 */
  const onClickDelete = () => {
    dispatch(setLenderDelete(true));
    let indexList: string[] = [];
    _deleteUser.forEach((user) => {
      indexList = [...indexList, user];
    });
    // 有償機能プランか否かで処理を分ける
    if (state.isDeviceActivate) {
      // 有償機能プランの場合は、同期版第三者利用権登録解除APIを実行
      dispatch(
        deleteLendingUserSync(
          _token,
          _refreshToken,
          _purchaseId,
          indexList,
          _language,
          false,
          true
        )
      );
    } else {
      // 有償機能プランではない場合は、今までの第三者利用権登録解除API(非同期版)を実行
      dispatch(
        deleteLendingUser(
          _token,
          _refreshToken,
          _purchaseId,
          indexList,
          _language,
          false,
          true
        )
      );
    }
  };

  /** キャンセルボタンの押下処理 */
  const onClickClose = () => {
    dispatch(setStatus(BoardStatus.LENDING_USER_DISP));
  };

  return {
    isDisplay: state.isDisplay,
    deleteUser: _deleteUser,
    isLendingUserProcessing: state.isLendingUserProcessing,
    isLendingUserProcessingFail: state.isLendingUserProcessingFail,
    glossary: state.glossary,
    onInit,
    onClickDelete,
    onClickClose
  };
};

export default function ContainerComponent() {
  const _props = { ...useMargeProps(useStateProps()) };
  return <DeleteLendingUserBoard {..._props} />;
}
